@if (icon) {
  <div >
    @for (value of arry; track value) {
      <div fxLayoutGap="10px" fxLayout="row" style="padding-top:5px" fxLayoutAlign="start start" >
        <div fxLayout="column" style="width:100%"   fxLayoutGap="10px">
          <div fxLayout="row" fxLayoutGap="10px"  >
            @if (icon) {
              <mat-icon   class="maticoncss">{{ matIcon }}</mat-icon>
            }
            <calsoft-editor-text-child style="width: 100%" fxLayoutAlign="start center"
              [data]="data"
              [text]="value"
              [id]="id"
              [align]="align"
              [fontSize]="fontSize"
              [data]="data"
              [MobfontSize]="MobfontSize"
              [fontFamily]="data?.websiteFontFamily">
            </calsoft-editor-text-child>
          </div>
        </div>
      </div>
    }
  </div>
}

@if (!icon) {
  <div >
    <div [id]="id" style="width:100%" [style.font-size]="fontSize" [ngStyle.lt-md]="{ 'font-size': MobfontSize }"
    [ngStyle]="{'font-family': data?.websiteFontFamily}" [innerHTML]="trustedHtmlContent"></div>
  </div>
}

